import React from 'react';
import { DragSource, DropTarget } from 'react-dnd';
import { Row, Col, Button, Clearfix, OverlayTrigger, Tooltip } from 'react-bootstrap';

import { getQuestionTypeIcon, getQuestionType, mayQuestionHaveOptions } from 'helpers/questionnaire';

import SimplePrompt from 'components/layout/SimplePrompt';

import { ROLE_CRM_MASTER } from 'js/constants';
import may from 'js/security';

const source = {
  beginDrag(props) {
    return {
      id: props.id,
      index: props.index,
    };
  },
};

const target = {
  hover(props, monitor, component) {
    const dragIndex = monitor.getItem().index;
    const hoverIndex = props.index;

    // Don't replace items with themselves
    if (dragIndex === hoverIndex) {
      return;
    }

    // Time to actually perform the action
    props.moveQuestion(dragIndex, hoverIndex);

    // Note: we're mutating the monitor item here!
    // Generally it's better to avoid mutations,
    // but it's good here for the sake of performance
    // to avoid expensive index searches.
    monitor.getItem().index = hoverIndex;
  },
};

@DropTarget('questionnaireQuestion', target, connect => ({
  connectDropTarget: connect.dropTarget(),
}))
@DragSource('questionnaireQuestion', source, (connect, monitor) => ({
  connectDragSource: connect.dragSource(),
  connectDragPreview: connect.dragPreview(),
  isDragging: monitor.isDragging(),
}))
export default class QuestionnaireQuestionDraggable extends React.Component {
  render() {
    const {
      intl: { messages },
      index,
      label,
      type,
      isRequired,
      showInLeadDescription,
      options,
      connectDragSource,
      connectDropTarget,
      connectDragPreview,
      user,
    } = this.props;

    const dragHandle = connectDragSource(<i className="fa fa-drag-handle m-r-10" />);
    const questionTypeIcon = getQuestionTypeIcon(type);

    return connectDragPreview(
      connectDropTarget(
        <div className="m-b-15 bg-master-light padding-10 b-rad-sm">
          <Row>
            <Col xs={8}>
              <div style={{ padding: '6px 0' }}>
                {dragHandle}
                <OverlayTrigger
                  placement="top"
                  overlay={<Tooltip>{(getQuestionType(type, messages) || {}).label}</Tooltip>}
                >
                  <i className={'fa-fw m-l-10 ' + questionTypeIcon} />
                </OverlayTrigger>{' '}
                <OverlayTrigger
                  placement="top"
                  overlay={
                    <Tooltip>
                      {showInLeadDescription
                        ? messages.this_answer_will_be_shown_in_lead_description
                        : messages.this_answer_will_not_be_shown_in_lead_description}
                    </Tooltip>
                  }
                >
                  <i
                    className={
                      'fa-fw m-r-10 fa fa-eye fa-fw ' +
                      (showInLeadDescription ? 'text-success ' : 'hint-text text-danger ')
                    }
                  />
                </OverlayTrigger>
                <span className="bold">{label}</span>
                {isRequired && <span className="m-l-10 text-danger">*</span>}
              </div>
            </Col>
            <Col xs={4}>
              <div className="text-right">
                <Button bsSize="sm" className="btn-rounded m-r-10" onClick={() => this.props.editQuestion(index)}>
                  <i className="fa fa-pencil-alt" /> {messages.edit}
                </Button>
                {may(ROLE_CRM_MASTER, user.roles) && (
                  <SimplePrompt
                    onSuccess={e => {
                      this.props.removeQuestion(index);
                    }}
                  />
                )}
              </div>
            </Col>
          </Row>

          {mayQuestionHaveOptions(type) && !!options && options.length > 0 && (
            <Row className="p-l-65 sm-p-l-20">
              <Col xs={12}>
                <p>{messages.options}:</p>
              </Col>

              {options.map(option => {
                return (
                  <Clearfix>
                    <Col xs={12} sm={9} md={6} className="m-b-10">
                      <div className="pull-left m-r-10">
                        <i className={'fa-fw ' + questionTypeIcon} />
                      </div>
                      <div className="pull-left">{option.getLabel()}</div>
                    </Col>
                  </Clearfix>
                );
              })}
            </Row>
          )}
        </div>
      )
    );
  }
}
